import { masterApiUrl } from "API/urls/master.api";
import { axiosInstance } from "configs/axios";

export const fetchDropDownsApi = async () => {
  try {
    const response = await axiosInstance.get(masterApiUrl.dropDowns);
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
